import React from "react";
import PropTypes from "prop-types";
import {observer, inject} from "mobx-react";
import {Route, Switch} from 'react-router-dom';
import { ThemeProvider } from "@octane/spark";
import {Container} from "react-bootstrap";

import {ServerError} from "../../components/interstitials";
import {withRideOctaneTitle, PageTitles} from "../../pages/octane-title";
import {startWidgetMessageListener} from '../utils/widget';
import {DigitalCreditAppFlowStore} from "./digital-credit-app-flow-store";
import {DigitalCreditAppStep} from "../steps/digital-credit-app-step";
import {Offers} from "../../prequal/offers";
import {ReturnToServer} from "../../components/return-to-server";

export const DigitalCreditAppFlow = inject(
        'rideOctaneStore',
        'apiStore',
        'themeStore',
        'partnerStore',
        'historyStore',
        'dealershipStore',
        'uxCopyStore'
    )(
    observer(
        class _DigitalCreditAppFlow extends React.Component {
            static propTypes = {
                match: PropTypes.shape({params: PropTypes.object}),
                partnerStore: PropTypes.object.isRequired,
                themeStore: PropTypes.object.isRequired,
            };

            store = new DigitalCreditAppFlowStore(this.props);

            componentDidMount() {
                if (this.store.isPartnerDealerWidgetExperience && !this.store.isVehicleSelfSelectionExperience) {
                    const stores = {
                        partnerStore: this.store.partnerStore,
                        dealershipStore: this.store.dealershipStore,
                        historyStore: this.store.historyStore,
                    }
                    const onWidgetTimeout = () => this.store.showServerErrorView("Widget Error.");
                    const onWidgetSuccess = () => this.store.initializeVehicleConfiguration();

                    this.stopWidgetMessageListener = startWidgetMessageListener(window, stores, onWidgetTimeout, onWidgetSuccess);
                } else {
                    this.store.initializeVehicleConfiguration();
                }
            }

            componentWillUnmount() {
                if (this.stopWidgetMessageListener) {
                    this.stopWidgetMessageListener();
                }
            }

            render() {
                if (this.store.showServerError) {
                    return (
                    <Container data-oid="digital-credit-app-flow-error-page">
                        <ServerError
                            origin="digital-credit-app-flow"
                            errorMessage={this.store.serverErrorMessage}
                        />
                    </Container>
                    );
                }

                const digitalCreditAppTitle = this.store.isCoapplicantFlow ?
                                    PageTitles.LONG_PREQUAL_COAPPLICANT_TITLE :
                                    PageTitles.LONG_PREQUAL_TITLE;
                const titleWords = this.store.displayVehicle ? [this.store.displayVehicle.name] : [];

                const theme = this.props.themeStore.buildSparkTheme();

                return (
                    <ThemeProvider theme={theme}>
                    <div>
                        <Switch>
                            <Route exact path={["/:slug?/apply", "/:slug?/apply/coapplicant"]}>
                                {withRideOctaneTitle(
                                    <DigitalCreditAppStep
                                        match={this.props.match}
                                        hasFetchedVehicle={this.store.hasFetchedVehicle}
                                        vehicleConfiguration={this.store.displayVehicle}
                                        isDummyVehicleEnabled={this.store.isDummyVehicleEnabled}
                                        rawVehicleData={this.store.rawVehicleData}
                                        isCoapplicantFlow={this.store.isCoapplicantFlow}
                                        flowStore={this.store}
                                    />, [...titleWords, digitalCreditAppTitle]
                                )}
                            </Route>
                            <Route exact path={["/:slug?/apply/offers/:appUuid", "/:slug?/apply/offers/:appUuid/:applicantUuid"]}>
                                {withRideOctaneTitle(
                                    <Offers
                                        applicationUuid={this.store.applicationUuid}
                                        applicantUuid={this.store.primaryApplicantUuid}
                                        hasCompletedAboutYouForm={this.store.hasCompletedDigitalCreditAppForm}
                                        hasSubmittedSSN={this.store.hasCompletedDigitalCreditAppForm}
                                        aboutYouPrequalUrl={this.store.getPrequalUrl()}
                                        ssnRequiredUrl={null}
                                        isApplicantCMPFlow={!!this.store.primaryApplicantUuid}
                                        accessoriesAmount={this.store.accessoriesAmount}
                                        vehicleConfiguration={this.store.displayVehicle}
                                        offersEndpoint={`/api/v2/applications/${this.store.applicationUuid}/`}
                                        hideVehicleHeaderBlock
                                    />,
                                    [...titleWords, PageTitles.OFFERS_TITLE]
                                )}
                            </Route>
                            <Route component={ReturnToServer} />
                        </Switch>
                    </div>
                    </ThemeProvider>
                );
            }
        }
    )
);
